<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'emailtemplates.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="emailtemplatesGrid" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import States from '@/components/Lists.js'
import router from '@/router'

export default {
  name: 'ActivitiesGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        },
        'ordering': {
          type: 'number',
          editable: false
        },
        'template_id': {
          type: 'number',
          editable: false
        }
      },
      url: 'email/templates',
      preload: [{
        api: 'activities/lst',
        field: 'activity_id'
      },{
        api: 'email/templates/mailables',
        field: 'template_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      },
      {
        field: 'template_id',
        title: 'Email',
        width: '180px',
        values: []
      },
      {
        field: 'state',
        title: 'Estado',
        width: '100px',
        values: States.states
      },
      {
        field: 'ordering',
        title: 'Ordem',
        width: '100px'
      },
      {
        field: 'activity_id',
        title: 'Actividade',
        width: '180px',
        values: []
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('emailtemplates.edit')) {
        var route = router.resolve({
          name: 'emailtemplates.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('emailtemplates.view')) {
        var route = router.resolve({
          name: 'emailtemplates.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
